import firebase from 'firebase';
import 'firebase/auth';
require('dotenv').config()

const app = firebase.initializeApp({
    apiKey: "AIzaSyAh72jkJzmBoQAEhNbnIBSvNmcKKtFuDdo",
    authDomain: "mindspace-b9895.firebaseapp.com",
    databaseURL: "https://mindspace-b9895.firebaseio.com",
    projectId: "mindspace-b9895",
    storageBucket: "mindspace-b9895.appspot.com",
    messagingSenderId: "600216590034",
    appId: "1:600216590034:web:fcd90ef22d1d27050d7f0b"
})
export const auth = app.auth();
export const db = app.firestore();
export default app